// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"823d949d","585":"7d56c7bb"}[chunkId] + ".chunk.js";
};